import { scheduleErrorCodes } from "./errorCodes/schedules";

export const errorCodes = {
  LICENCE_EXPIRED: 1001,
  POSITION_ALREADY_EXIST: 3001,
  POSITION_NOT_EXIST: 3002,
  COMPANY_NOT_EXIST: 5001,
  REGION_NOT_EXIST: 6001,
  ORGANISATION_STRUCTURE_PARENT_NOT_EXIST: 2001,
  ORGANISATION_STRUCTURE_TYPE_NOT_EXIST: 2002,
  ORGANISATION_STRUCTURE_USER_NOT_EXIST: 2003,
  ORGANISATION_STRUCTURE_REPORTS_TO_NOT_EXIST: 2004,
  ORGANISATION_STRUCTURE_NOT_EXIST: 2005,
  ORGANISATION_USERS_EXISTS : 2100,
  ORGANISATION_CONTRACT_EXISTS : 2101,
  MANAGER_REMOVE: 4001,
  ACCOUNT_NOT_FOUND: 7001,
  ACCOUNT_2FA_NOT_FOUND: 7002,
  ACCOUNT_IS_NOT_SUPERADMIN: 7003,
  ACCOUNT_2FA_UNAUTHORIZED: 7004,
  ACCOUNT_ALREADY_VERIFIED: 7005,
  ACCOUNT_ALREADY_REGISTERED: 7006,
  // Distinct from ACCOUNT_ALREADY_REGISTERED (was also 7006) so OTP flows and the
  // social-signup flow can't be confused by a handler that sees both.
  ACCOUNT_WRONG_OTP: 7034,
  ACCOUNT_OTP_EXPIRED: 7007,
  ACCOUNT_PORTAL_IS_REQUIRED: 7008,
  ACCOUNT_UNAUTHORIZED_ACTION: 7012,
  SOMETHING_WENT_WRONG: 9000,
  RECAPTCHA_UNUSUAL_TRAFFIC: 9001,
  ORIGIN_NOT_FOUND: 8000,
  RULE_CONTAIN_FIELD: 8800,
  RULE_UPDATE_ORGSTRUCTURE_ERROR: 8801,
  RULE_PERSONALINFORMATION_CHANGE_ERROR: 8802,
  QUERIES_DISTINCTPROPERTY_NOTFOUND: 9001,
  FILE_NOTFOUND: 9100,
  FILE_ESCROWED: 9101,
  REVISION_INVALID: 9102,
  COST_DATABASE_ITEM_DELETED_IN_LATEST_VERSION: 9200,
  COST_DATABASE_ITEM_RATE_DELETED_IN_LATEST_VERSION: 9201,
  INCORRECT_PASSWORD: 7009,
  INVITATION_EXPIRED: 7010,
  ACCOUNT_UNVERIFIED: 7011,
  INSUFFICIENT_PERMISSION: 7012,
  FAILED_TO_SAVE_AT_SPACE: 7013,
  FEW_FILES_FAILED_TO_UPLOAD: 7014,
  SPACE_NOT_FOUND: 7015,
  DELETE_DEFAULT_SPACE: 7016,
  INVALID_JSON: 7017,
  ISSUE_NOT_FOUND : 11001,
  ISSUE_NO_ACCESS : 11002,
  ESTIMATE_NOT_FOUND : 1101,
  ESTIMATE_NO_ACCESS : 1100,
  ESTIMATE_COST_DATABASE_UPGRADE_TAKEOFF_WIZARD_ERROR : 1201,
  DEFAULT_COST_DATABASE_DELETE : 1301,
  COST_DATABASE_ATTACHED_TO_ESTIMATE : 1302,
  ACCOUNT_SUSPENDED_IN_PORTAL: 7018,
  ADDONS_NO_ACCESS : 7019,
  ACCOUNT_PASSWORD_EXPIRED: 7020,
  ACCOUNT_PASSWORD_REUSED: 7021,
  ACCOUNT_PASSWORD_TOO_WEAK: 7022,
  ESTIMATE_GETVALIDITEMS_COST_DATABASE_NOT_EXISTS : 1102,
  COST_DATABASE_PARENT_ITEM_NOT_FOUND : 1103,
  SELECTION_SET_ALREADY_EXISTS : 12000,
  ACCOUNT_RATE_LIMIT_EXCEEDED: 7023,
  ACCOUNT_LOCKED: 7024,
  ACCOUNT_RESET_TOKEN_INVALID: 7025,
  SOCIAL_SIGNUP_UNSUPPORTED_PROVIDER: 7026,
  SOCIAL_SIGNUP_INVALID_CREDENTIAL: 7027,
  ACCOUNT_NO_PASSWORD_SOCIAL_ONLY: 7028,
  ACCOUNT_SOCIAL_ACCOUNT_NOT_LINKED: 7029,
  // The verified provider identity (sub) is already linked to a DIFFERENT account.
  SOCIAL_ACCOUNT_ALREADY_LINKED_ELSEWHERE: 7030,
  // Unlink refused: this is the user's only remaining sign-in method and no
  // password is set, so removing it would lock them out. Set a password first.
  SOCIAL_CANNOT_UNLINK_LAST_METHOD: 7031,
  // Password-change identity step: neither current password nor OTP supplied
  // for a user who has a password set.
  ACCOUNT_PASSWORD_OR_OTP_REQUIRED: 7032,
  // Password-change OTP: too many wrong attempts — temporarily locked out.
  // Response carries `lockedUntil` (epoch ms) for the retry countdown.
  ACCOUNT_OTP_LOCKED: 7033,
  ACCOUNT_NO_PASSWORD_OTP_ONLY: 7035,
  ...scheduleErrorCodes
};
